import * as React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button, Container, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import Navbar from '../../components/Navbar';
import { useForm, Controller } from "react-hook-form";
import instance from "./../../axios/instance";
import Loading from '../../components/Loading';
import PaidIcon from "@mui/icons-material/Paid";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useSelector } from 'react-redux';
import useCurrency from '../../hooks/useCurrency';
import { convertCurrency } from '../../utils/convertCurrency';

function PackageInfo() {
  const { teacherId, packageId } = useParams();
  const { student } = useSelector((state) => state.student);
  const { currency } = useSelector((state) => state.currency);
  const currencyObj = useCurrency(currency);
  const { conversionRate } = useSelector((state) => state.conversionRate);
  const [studentPackage, setStudentPackage] = React.useState(null);
  const navigate = useNavigate();
  const [tolPrice, setTotalPrice] = React.useState(0.0);
  const lang = Cookies.get("i18next") || "en";
  const { t } = useTranslation();
  const [load, setLoad] = React.useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      typeofbook: "",
    },
  });
  React.useEffect(() => {
    (async () => {
      const response = await instance(`packages/get-package/${packageId}`);
      const result = await convertCurrency(response.data.price,response.data.currency,currency);
      const data = response.data;
      setTotalPrice(result);
      setStudentPackage(data);
    })();
  }, [packageId, tolPrice,currency]);

  
  async function onSubmit(data) {
    const PriceMony = await convertCurrency(+studentPackage.price,studentPackage.currency,"OMR");
    const tmpData = {
      StudentId: student.id,
      TeacherId: teacherId,
      price: +PriceMony,
      title: `package ${studentPackage.titleAr}`,
      currency: "OMR",
      PackageId: studentPackage.id,
      typeOfPayment: data.typeofbook,
      period: 1,
      date: new Date(),
      type: studentPackage.packageType,
    };
    
    setLoad(true);
    closeSnackbar();
    try {
      const response = await instance.post("payment/booking", tmpData);
      const fetchData = response.data;
      setLoad(false);
      if (data.typeofbook === "wallet" || data.typeofbook === "points") {
        navigate("/student/package");
        enqueueSnackbar(
          t(fetchData.msg),
          { variant: "success", autoHideDuration: 8000 }
        );
      } else {
        window.location.replace(fetchData.data);
      }
    } catch (err) {
      setLoad(false);
      const message =  t(err.response?.data.msg);
      enqueueSnackbar(t(message), {
        variant: "error",
        autoHideDuration: "5000",
      });
    }
  }

  if (!studentPackage) return <Loading />
  else return (
    <Navbar>
      <Container sx={{ marginY: "100px" }}>
        {/* <h1 className='text-3xl text-center mb-3'>{t("packageInfo")}</h1> */}
        <Card variant="outlined" sx={{ width: "100%" }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ p: 2 }}>
              <Controller
                name="typeofbook"
                control={control}
                render={({ field }) => (
                  <RadioGroup {...field}>
                                       <FormControlLabel
                                          value="points"
                                          control={<Radio size="2px" />}
                                          label={t("Buy with points")}
                                        />
                    <FormControlLabel
                      value="wallet"
                      control={<Radio size="2px" />}
                      label={`${t("credit")} (${t("wallet")})`}
                    />
                    <FormControlLabel
                      value="thawani"
                      control={<Radio size="2px" />}
                      label={t("gateway")}
                    />
                  </RadioGroup>
                )}
                {...register("typeofbook", {
                  required: "typeofbook Address is required",
                })}
              />
              {errors.typeofbook?.type === "required" && (
                <Typography
                  color="error"
                  role="alert"
                  sx={{ fontSize: "13px", marginTop: "6px" }}
                >
                  {t("required")}
                </Typography>
              )}
            </Box>
            <Box sx={{ p: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "14px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "6px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#005B8E",
                      color: "white",
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <PaidIcon sx={{ fontSize: "15px" }} />
                  </Box>
                  <Typography sx={{ fontSize: "14px" }}>
                    {t("totlaPackagePrice")}
                  </Typography>
                </Box>
                <Typography>
                 {tolPrice} {t(currency)}
                </Typography>
              </Box>
            </Box>
            <div className='mb-2'>
              {!load ? (
                <Button fullWidth type="submit" variant="contained">
                  {t("next")}
                </Button>
              ) : (
                <Button fullWidth variant="contained">
                  {t("next")}...
                </Button>
              )}
            </div>
          </form>
        </Card>
      </Container>
    </Navbar>
  )
}

export default PackageInfo;
